import styled from "styled-components"
import CssBaseline from "@material-ui/core/CssBaseline"
import { createBrowserRouter, RouterProvider } from "react-router-dom"
import { MainContainer } from '../MainContainer'
import { WatcherMainContainer } from '../WatcherMainContainer'
import { SignerBatchMainContainer } from "../SignerBatchMainContainer"
import { RedirectContainer } from '../RedirectContainer'
import { NotFoundPage } from '../NotFoundPage'
import { UnsupportedDevicePage } from '../UnsupportedDevicePage'
import { EnvelopeFolderMainContainer } from '../EnvelopeFolderMainContainer'
import { defaultThemeSettings } from '../../utils/utils'
import { ThemeProvider } from "src/contexts/ThemeContext"

const Main = styled.main`
    height: 100vh;
    height: 100dvh;
    width: 100vw;
    background-color: #f8f8f8;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const MainRouter = (props) => {

    const { isInvalidBrowser, isInvalidOS, signMetadata, setSignMetadata } = props;

    const router = createBrowserRouter([
        {
            path: "/s/:signerHash",
            element: <MainContainer setSignMetadata={setSignMetadata} signMetadata={signMetadata}/>
        },
        {
            path: "/r/:signerHash",
            element: <RedirectContainer setSignMetadata={setSignMetadata} signMetadata={signMetadata}/>
        },
        {
            path: "/sb/:signerBatchHash",
            element: <SignerBatchMainContainer />
        },
        {
            path: "/w/:watcherHash",
            element: <WatcherMainContainer />
        },
        {
            path: "/ef/:folderHash",
            element: <EnvelopeFolderMainContainer setSignMetadata={setSignMetadata} signMetadata={signMetadata} />
        },
        {
            path: "*",
            element: <NotFoundPage clientThemeSettings={defaultThemeSettings} />
        }
    ])

    return (
        <div>
            <ThemeProvider>
                <CssBaseline />
                <Main>
                    {signMetadata?.face && (isInvalidBrowser || isInvalidOS) ? <UnsupportedDevicePage isInvalidBrowser={isInvalidBrowser} isInvalidOS={isInvalidOS} signMetadata={signMetadata} /> : <RouterProvider router={router} />}
                </Main>
            </ThemeProvider>
        </div>
    )
}
